import { useState } from "react";
import "./EmailConfirmation.css";
import Button from "../../../components/button/Button";
import { useLocation, useNavigate } from "react-router-dom";
import Modal from "../../../components/modal/Modal";

import { useBrandContext } from "../../../context/BrandContext";

interface Props {
  isModalOpen: boolean;
  setIsModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
  allowButtonClosed: boolean;
  email: string;
}

const EmailConfirmation: React.FC<Props> = ({isModalOpen, setIsModalOpen, allowButtonClosed, email}) => {
  const navigate = useNavigate();
  const location = useLocation();

  const brandContext = useBrandContext();
    // const routePaths = location.pathname.split('/');
  
  const backToLogin = () => {
    setIsModalOpen(false);
    navigate(`/${brandContext.brandName}/login`);
  }

  return (
    <>
      <Modal 
        allowButtonClosed={allowButtonClosed}
        isOpen={isModalOpen}
        title="Conta criada com sucesso!"
        onClose={() => setIsModalOpen(false)}
      >
        <p className="email-confirmation-modal-text">
            Enviamos um e-mail de confirmação para <b>{email ? email : "o seu e-mail"}</b>. 
            Caso não encontre, pode estar na sua caixa de spam.
        </p>
        <Button
          style={{backgroundColor: '#fff', color: '#787E7D', border: '1px solid #787E7D'}}
          type= 'button'
          children = "Voltar para o login"
          onClick={backToLogin}
        />
      </Modal>
    </>
  );
};

export default EmailConfirmation;
